import React from 'react';
import {GlobalLoader} from '../GlobalLoader';
import styles from './AppLoading.scss';

function AppLoading() {
  return (
    <div className={styles.appLoadingWrapper} data-hook="appLoadingWrapper">
      <GlobalLoader />
    </div>
  );
}

export {AppLoading};
